import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
const timelineData = [{
  year: '2015',
  desc: 'Detailní analýza trhu a developerských modelů'
}, {
  year: '2016',
  desc: 'Definice strategie a zahájení přípravy projektu'
}, {
  year: '2016–2022',
  desc: 'Projekční práce a získání stavebního povolení'
}, {
  year: 'od 2023',
  desc: 'Zahájení realizace a infrastruktury'
}];
export function Timeline() {
  const {
    t
  } = useLanguage();
  const timelineItems = t('timeline.items');
  const currentBullets = t('timeline.current.bullets');
  return <section className="py-32 px-6 bg-bg-primary" data-id="element-72">
      <div className="max-w-4xl mx-auto" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-16" data-id="element-74">
          <h2 className="text-3xl md:text-5xl font-serif text-white mb-6" data-id="element-75">
            {t('timeline.title')}
          </h2>
          <div className="h-px bg-gold w-24 opacity-50" data-id="element-76"></div>
        </motion.div>

        <div className="relative pl-8 md:pl-0" data-id="element-77">
          {/* Vertical Line */}
          <div className="absolute left-[11px] md:left-1/2 md:-translate-x-1/2 top-0 bottom-0 w-px bg-[#222]" data-id="element-78">
            <div className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-gold to-transparent" data-id="element-79"></div>
          </div>

          <div className="space-y-12" data-id="element-80">
            {timelineItems.map((item: any, idx: number) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: idx * 0.1
          }} className={`relative flex flex-col md:flex-row items-start md:items-center ${idx % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-81">
                <div className="hidden md:block w-1/2" data-id="element-82"></div>

                {/* Dot */}
                <div className="absolute left-[-21px] md:left-1/2 md:-translate-x-1/2 w-3 h-3 rounded-full bg-gold shadow-[0_0_10px_rgba(196,151,60,0.5)] z-10 mt-1.5 md:mt-0" data-id="element-83"></div>

                <div className={`w-full md:w-1/2 ${idx % 2 === 0 ? 'md:pl-12' : 'md:pr-12 md:text-right'} pl-6 md:pl-0`} data-id="element-84">
                  <span className="text-gold font-serif text-xl block mb-2" data-id="element-85">
                    {item.year}
                  </span>
                  <p className="text-gray-400 font-light" data-id="element-86">{item.desc}</p>
                </div>
              </motion.div>)}

            {/* Current Status */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="relative flex flex-col md:flex-row items-start md:items-center" data-id="element-87">
              <div className="hidden md:block w-1/2" data-id="element-88"></div>

              {/* Large Dot */}
              <div className="absolute left-[-25px] md:left-1/2 md:-translate-x-1/2 w-5 h-5 rounded-full border-2 border-gold bg-bg-primary z-10 mt-1 md:mt-0 flex items-center justify-center" data-id="element-89">
                <div className="w-2 h-2 rounded-full bg-gold" data-id="element-90"></div>
              </div>

              <div className="w-full md:w-1/2 md:pl-12 pl-6" data-id="element-91">
                <div className="bg-[#1A1A1A] border border-gold/30 p-6 rounded-sm" data-id="element-92">
                  <span className="text-gold font-serif text-2xl block mb-4" data-id="element-93">
                    {t('timeline.current.title')}
                  </span>
                  <ul className="space-y-3 text-gray-300 font-light text-sm mb-6" data-id="element-94">
                    {currentBullets.map((bullet: string, idx: number) => <li key={idx} className="flex items-start" data-id="element-95">
                        <span className="text-gold mr-2 mt-0.5" data-id="element-96">•</span>
                        <span data-id="element-97">{bullet}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Financing Section - compact */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mt-16 pt-8 border-t border-[#222] flex flex-wrap gap-x-16 gap-y-6 text-sm text-gray-500 font-light items-end justify-center" data-id="element-98">
          <div data-id="element-99">
            <span className="text-gray-400 mr-2" data-id="element-100">
              {t('timeline.financing.label1')}
            </span>
            {t('timeline.financing.text1')}
          </div>
          <div data-id="element-101">
            <span className="text-gray-400 mr-2" data-id="element-102">
              {t('timeline.financing.label2')}
            </span>
            {t('timeline.financing.text2')}
          </div>
        </motion.div>
      </div>
    </section>;
}